import { useNavigate, Link } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { Logo } from "./Logo";
import { UserMenu } from "./UserMenu";
import { useTheme } from "@/hooks/useTheme";

interface TopBarProps {
  title?: string;
  icon?: React.ElementType;
}

export function TopBar({ title = "Platform", icon: Icon = LayoutGrid }: TopBarProps) {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();

  return (
    <header className="h-14 flex items-center justify-between px-3 sm:px-6 border-b border-white/10 bg-surface-topbar shrink-0 relative z-60">
      {/* Logo */}
      <div className="flex items-center w-auto sm:w-48 text-white h-9">
        <Link to="/home" aria-label="Go to home" className="cursor-pointer h-full">
          <Logo />
        </Link>
      </div>

      {/* Main Title */}
      <button
        onClick={() => navigate("/home")}
        className="hidden sm:flex items-center gap-3 select-none group rounded-md px-2 py-1 -m-1 hover:bg-white/5 transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cyan/50"
        aria-label="Go to home"
      >
        <div className="flex items-center justify-center relative">
          <div className="absolute inset-0 bg-brand-cyan/20 blur-[6px] rounded-full" />
          <Icon
            className="h-5 w-5 text-brand-cyan drop-shadow-sm relative z-10"
            strokeWidth={1.8}
          />
        </div>
        <div className="flex items-center gap-2.5">
          <span className="text-[14px] font-semibold tracking-[0.15em] text-white/90 uppercase">
            SOC
          </span>
          <span className="w-px h-3.5 bg-white/20 rotate-15"></span>
          <span className="text-[14px] font-medium text-white/70 tracking-wide group-hover:text-white/90 transition-colors">
            {title}
          </span>
        </div>
      </button>

      {/* User menu */}
      <div className="flex items-center sm:w-48 justify-end">
        <UserMenu theme={theme} setTheme={setTheme} />
      </div>
    </header>
  );
}
